import { createContext } from 'react';

const WindowContext = createContext<(Window & typeof globalThis) | null>(null);

const { Provider: WindowProvider } = WindowContext;

export { WindowContext, WindowProvider };
